<template>
  <div class="layout">
    <header>
      <!-- 头部 -->
      <slot name="header">
        <Header></Header>
      </slot>
    </header>
    <!-- 主体内容 -->
    <main>
      <slot name="main">
        <router-view />
      </slot>
    </main>
    <!-- 底部 -->
    <footer>
      <slot name="footer">
        <Footer></Footer>
      </slot>
    </footer>
  </div>
</template>
<script>
  import {Header, Footer} from './components';
  export default {
    name: 'Layout',
    components: {
      Header,
      Footer
    }
  }
</script>


// WEBPACK FOOTER //
// src/layout/index.vue